import { defineMessages } from 'react-intl';

const scope = 'cb.screens';

export default defineMessages({
  youEarnedPointsTitle: {
    id: `${scope}.youEarnedPointsTitle`,
    defaultMessage: 'You earned {points, plural, one {# point} other {# points}}',
  },
  pointText: {
    id: `${scope}.pointText`,
    defaultMessage: 'points',
  },
  pointsAssignmentText: {
    id: `${scope}.pointsAssignmentText`,
    defaultMessage: 'Points can be used to purchase products and services from our participating coupons',
  },
  statusText: {
    id: `${scope}.statusText`,
    defaultMessage: 'Business marketer',
  },
  yourStatusText: {
    id: `${scope}.yourStatusText`,
    defaultMessage: 'You are now a {statusText}! You can share your code with businesses',
  },
  referralProgramCodeTitle: {
    id: `${scope}.referralProgramCodeTitle`,
    defaultMessage: 'Share and Earn',
  },
  referralsText: {
    id: `${scope}.referralsText`,
    defaultMessage: 'Friends',
  },
  referralCodeInstructionText: {
    id: `${scope}.referralProgramCode`,
    defaultMessage: 'Share this QR code with your {targetText} and earn 500 points every year they join Premium!',
  },
  paymentInformationTitle: {
    id: `${scope}.paymentInformationTitle`,
    defaultMessage: 'Payment information',
  },
  renewalDate: {
    id: `${scope}.renewalDate`,
    defaultMessage: '{renewalDate, date, ::MMMddyyyy}',
  },
  yourRenewalDateText: {
    id: `${scope}.yourRenewalDateText`,
    defaultMessage: 'Your renewal date is {renewalDateText}',
  },
  legalInformationTitle: {
    id: `${scope}.legalInformationTitle`,
    defaultMessage: 'Legal information',
  },
  privacyPolicyText: {
    id: `${scope}.privacyPolicyText`,
    defaultMessage: 'Privacy Policy',
  },
  termsOfServiceText: {
    id: `${scope}.termsOfServiceText`,
    defaultMessage: 'Terms of Service',
  },
  hasFreePlan: {
    id: `${scope}.hasFreePlan`,
    defaultMessage: 'You have free subscription',
  },
  subscribe: {
    id: `${scope}.subscribe`,
    defaultMessage: 'Subscribe',
  },
  deleteAccountText: {
    id: `${scope}.deleteAccountText`,
    defaultMessage: 'Delete Account',
  },
});
